function isVisible(element) {
  return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
}

function focusTrap(element) {
  const focusableEls = Array.from(
    element.querySelectorAll(
      '[role="button"]:not([disabled]), a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [role="link"]:not([disabled]), [role="checkbox"]:not([disabled]), [role="input"]:not([disabled]), [role="radio"]:not([disabled]), [tabindex]:not([tabindex="-1"])',
    ),
  ).filter(isVisible)

  if (focusableEls.length === 0) {
    return;
  }

  const firstFocusableEl = focusableEls[0]
  const lastFocusableEl = focusableEls[focusableEls.length - 1]

  element.addEventListener('keydown', function (e) {
    if (e.key === 'Tab' || e.keyCode === 9) {
      if (e.shiftKey) {
        if (document.activeElement === firstFocusableEl) {
          // if focused on first element and user presses shift + tab
          lastFocusableEl.focus()
          e.preventDefault()
        }
      } else {
        // if focused on last element and user presses tab
        if (document.activeElement === lastFocusableEl) {
          firstFocusableEl.focus()
          e.preventDefault()
        }
      }
    }
  })
}

export default focusTrap